export function getDomain(url) {
  const urlMainParts = url.split("?");
  return urlMainParts[0].split("/persis/")[0];
}

export function getUrlMainParts(url) {
  const urlMainParts = url.split("?");
  let urlParamParts = urlMainParts[1].split("&");

  urlParamParts = urlParamParts.filter(url => !url.startsWith("_forceNav"));

  const fn = urlParamParts.filter(
    url => url.startsWith("fn") || url.startsWith("function")
  );
  if (fn && fn.length) {
    const funktion = fn[0].split("=")[1];
    let resultUrl = `/main/${funktion}`;
    const action = urlParamParts.filter(url => url.startsWith("action"));
    if (action && action.length) {
      const actionParam = action[0].split("=")[1];
      resultUrl += `/${actionParam}`;
    }

    if (urlParamParts && urlParamParts[1]) {
      const paramsWithoutFunctionAction = urlParamParts.filter(
        url =>
          !url.startsWith("fn") &&
          !url.startsWith("function") &&
          !url.startsWith("action")
      );
      if (paramsWithoutFunctionAction && paramsWithoutFunctionAction.length) {
        resultUrl += `?${paramsWithoutFunctionAction.join("&")}`;
      }
    }
    return resultUrl;
  }

  return url;
}

export function getIframeUrl(url) {
  return getDomain(url) + getUrlMainParts(url);
}

export const getNavigationPermissions = ({
  atomIframeUrl,
  lastNavigationUrl,
  targetUrl,
  iframeRef
}) => {
  // Fall 1: Iframe ist nicht im Dom enthalten
  // 1. Hier sollte abgebrochen werden, da die router Navigation genügt
  const iframeNotRendered = iframeRef === undefined;

  // Fall 2: Seite wurde geladen, 'navigation-item-click' Event wurde jedoch noch nicht gefeuert.
  // 1. lastNavigationUrl ist leer
  // 2. Hier sollte abgebrochen werden, da die router Navigation genügt
  const lastNavigationUrlIsNotDefined = !lastNavigationUrl;

  // Fall 3: In der Hauptnavigation wurde ein nicht aktiver Link geklicked
  // 1. Hier sollte abgebrochen werden, da die router Navigation genügt
  const noActiveItemClicked = lastNavigationUrl !== targetUrl;

  // Fall 4:
  // 1. Hauptnavigation wurde der aktive Link nochmals geklicked
  // 2. Eine Fusion Navigation wurde nicht durchgeführt => 'atomIframeUrl' ist die selbe wie 'lastNavigationUrl'
  // 3. Hier sollte abgebrochen werden, da die router Navigation genügt
  const activeItemClickedTwiceWithoutFusionNavigation =
    lastNavigationUrl === targetUrl && targetUrl === atomIframeUrl;

  // Fall 5: Es wird von einer Fusionseite zu einer Atomseite navigiert
  // 1. Das Iframe ist noch im Dom sodass die Prüfung auf 'this.$refs.persisFusionFrame === undefined' fehlschlägt
  // 2. Hier sollte abgebrochen werden, da die router Navigation genügt
  const fromFusionToAtomNavigation =
    targetUrl && !targetUrl.startsWith("/main");

  // Fall 6: Es wird von einer Atomseite zu einer Fusionseite navigiert
  // 1. Hier sollte abgebrochen werden, da die router Navigation genügt
  const fromAtomToFusionNaviagtion =
    !lastNavigationUrl.startsWith("/main") && targetUrl.startsWith("/main");

  // Fall 7:
  // 1. Die Fälle 1 - 6 haben die Navigation nicht abgebrochen
  // 2. In der Hauptnavigation wurde der aktive Link nochmals geklicked
  // 3. Eine Fusion Navigation wurde durchgeführt => 'atomIframeUrl' unterscheidet sich von 'lastNavigationUrl'
  // 4. Hier muss navigiert werden, da die router Navigation nicht reagiert
  const navigationIsAllowed =
    lastNavigationUrl === targetUrl && targetUrl !== atomIframeUrl;

  const navigationIsDisallowed =
    iframeNotRendered ||
    lastNavigationUrlIsNotDefined ||
    noActiveItemClicked ||
    activeItemClickedTwiceWithoutFusionNavigation ||
    fromFusionToAtomNavigation ||
    fromAtomToFusionNaviagtion;

  return {
    navigationIsAllowed,
    navigationIsDisallowed
  };
};
